/**************************************************
 * Nombre:       Inicio_Noticias
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../../Servicios/BD/obtenerCol";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import Tarjeta_Noticias from "../../Tarjetas/Tarjeta_Noticias";

const Inicio_Noticias = () => {
    const [noticias, setNoticias] = useState([])


    useEffect(() => {
        obtenerCol('noticias').then((dox) => {
            setNoticias(dox.data)
        })
    }, []);
    return (
        <Grid
            container
            direction="row-reverse"
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{color: '#fff'}}
            spacing={4}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Splide
                    aria-label="My Favorite Images" style={{width: '100%'}}
                    options={{
                        autoplay: true,
                        speed: 1500,
                        rewind: true,
                        perPage: 1,
                        arrows: true,
                        pagination: false,
                        width: '100%',
                        drag: 'false',
                        interval: 5000,
                        noDrag: true,
                        type: 'fade'

                    }}
                >

                    {noticias.map((it, index) => {
                        return (
                            <SplideSlide key={`qe${index}`}>
                                <Tarjeta_Noticias item={it}/>
                            </SplideSlide>
                        )
                    })}


                </Splide>
            </Grid>


        </Grid>
    )

}
export default Inicio_Noticias